import { imageMapper } from 'data-source/mappers/imageMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { ApiComponent, ApiComponentFaq } from 'data-source/types.wp'
import { DSNCFaq, DSResource } from 'shared-definitions/types'

interface FaqOpts<T extends DSResource, A extends ApiComponent> extends PLinkMapperOpts {
  componentItemMapper: (input: A) => T | T[]
}

export function ncFaq<T extends DSResource, A extends ApiComponent>(
  input: ApiComponentFaq<A>,
  opts: FaqOpts<T, A>
): DSNCFaq<T> {
  return {
    icon: input.icon === 'ask-question' ? 'ask-question' : null,
    resource: 'nc-faq',
    question: input.question,
    image: imageMapper(input.image, opts),
    blocks: input.content.flatMap(opts.componentItemMapper),
    analytics: null,
    evaluateBlock: null,
  }
}
